import React from 'react';
import styled from 'styled-components';
import { 
  Coffee, 
  Users, 
  Settings, 
  Heart, 
  Lock, 
  ShoppingBag, 
  FileText, 
  ExternalLink
} from 'lucide-react';

const Sidebar = styled.div`
  width: 280px;
  background: #000000;
  border-right: 2px solid #e0c16f;
  position: fixed;
  height: 100vh;
  overflow-y: auto;
  padding-bottom: 120px;
  
  /* Custom scrollbar styling */
  &::-webkit-scrollbar {
    width: 8px;
  }
  
  &::-webkit-scrollbar-track {
    background: #000000;
  }
  
  &::-webkit-scrollbar-thumb {
    background: #e0c16f;
    border-radius: 4px;
  }
  
  &::-webkit-scrollbar-thumb:hover {
    background: #bd851b;
  }
  
  /* Firefox scrollbar */
  scrollbar-width: thin;
  scrollbar-color: #e0c16f #000000;
`;

const SidebarHeader = styled.div`
  background: linear-gradient(95.36deg, #e0c16f 5.18%, #bd851b 93.21%);
  padding: 24px;
  display: flex;
  align-items: center;
  gap: 12px;
  
  svg {
    width: 32px;
    height: 32px;
    color: #000000;
  }
`;

const SidebarNav = styled.nav`
  padding: 24px 0 60px 0;
`;

const NavSection = styled.div`
  margin-bottom: 32px;
  
  &:last-child {
    margin-bottom: 24px;
  }
`;

const NavSectionTitle = styled.h3`
  font-family: var(--font-heading);
  font-size: 0.75rem;
  font-weight: 600;
  color: #e0c16f;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin: 0 24px 16px;
`;

const NavItem = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 24px;
  color: #ffffff;
  cursor: pointer;
  transition: all 0.2s ease;
  font-family: var(--font-body);
  
  &:hover {
    background: #e0c16f;
    color: #000000;
  }
  
  &.active {
    background: #e0c16f;
    color: #000000;
    font-weight: 500;
  }
  
  svg {
    width: 20px;
    height: 20px;
  }
`;

const CreatorSidebar = ({ 
  user, 
  activeSection, 
  onNavItemClick
}) => {
  const handleNavItemClick = (section) => {
    onNavItemClick(section);
  };

  return (
    <Sidebar>
      <SidebarHeader>
        <Coffee />
        <span style={{ fontFamily: 'var(--font-heading)', fontWeight: '600' }}>
          Creator Hub
        </span>
      </SidebarHeader>
      
      <SidebarNav>
        {/* View Page Section */}
        <NavSection>
          <NavItem 
            onClick={() => handleNavItemClick('view-page')}
            className={activeSection === 'view-page' ? 'active' : ''}
          >
            <ExternalLink />
            View page
          </NavItem>
        </NavSection>

        {/* Explore Creators */}
        <NavSection>
          <NavItem 
            onClick={() => handleNavItemClick('explore-creators')}
            className={activeSection === 'explore-creators' ? 'active' : ''}
          >
            <Users />
            Explore creators
          </NavItem>
        </NavSection>

        {/* Monetize Section */}
        <NavSection>
          <NavSectionTitle>Monetize</NavSectionTitle>
          
          <NavItem 
            onClick={() => handleNavItemClick('supporters')}
            className={activeSection === 'supporters' ? 'active' : ''}
          >
            <Heart />
            Supporters
          </NavItem>
          
          <NavItem 
            onClick={() => handleNavItemClick('memberships')}
            className={activeSection === 'memberships' ? 'active' : ''}
          >
            <Lock />
            Memberships
          </NavItem>
        </NavSection>

        {/* Content Management Section */}
        <NavSection>
          <NavSectionTitle>Content Management</NavSectionTitle>
          
          <NavItem 
            onClick={() => handleNavItemClick('feed')}
            className={activeSection === 'feed' ? 'active' : ''}
          >
            <FileText />
            Feed Posts
          </NavItem>
          
          <NavItem 
            onClick={() => handleNavItemClick('shop-management')}
            className={activeSection === 'shop-management' ? 'active' : ''}
          >
            <ShoppingBag />
            Shop Management
          </NavItem>
          
        </NavSection>

        {/* Settings Section */}
        <NavSection>
          <NavSectionTitle>Settings</NavSectionTitle>
          
          <NavItem 
            onClick={() => handleNavItemClick('settings')}
            className={activeSection === 'settings' ? 'active' : ''}
          >
            <Settings />
            Settings
          </NavItem>
        </NavSection>
      </SidebarNav>
    </Sidebar>
  );
};

export default CreatorSidebar;
